module.exports = __webpack_public_path__ + "static/media/parachute.f29dba08.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/page/home/partners/images/parachute.png
// module id = 1878
// module chunks = 146